import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewGuide from "@/pages/NewGuide";
import GuideDetail from "@/pages/GuideDetail";
import StorePage from "@/pages/StorePage";
import PipelinePage from "@/pages/PipelinePage";
import BatchPage from "@/pages/BatchPage";
import SalesPage from "@/pages/SalesPage";
import PacksPage from "@/pages/PacksPage";
import TownsPage from "@/pages/TownsPage";
import RelocationPage from "@/pages/RelocationPage";
import ComparePage from "@/pages/ComparePage";
import CompareDetail from "@/pages/CompareDetail";
import RelocationDetail from "@/pages/RelocationDetail";
import RegisterPage from "@/pages/RegisterPage";
import CalculatorsPage from "@/pages/CalculatorsPage";
import ManageAlertsPage from "@/pages/ManageAlertsPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/calculators" element={<CalculatorsPage />} />
            <Route path="/calculators/alerts" element={<ManageAlertsPage />} />
            <Route element={<ProtectedRoute><Shell /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/new" element={<NewGuide />} />
              <Route path="/guides/:id" element={<GuideDetail />} />
              <Route path="/store" element={<StorePage />} />
              <Route path="/pipeline" element={<PipelinePage />} />
              <Route path="/batch" element={<BatchPage />} />
              <Route path="/sales" element={<SalesPage />} />
              <Route path="/packs" element={<PacksPage />} />
              <Route path="/towns" element={<TownsPage />} />
              <Route path="/compare" element={<ComparePage />} />
              <Route path="/compare/:id" element={<CompareDetail />} />
              <Route path="/relocation" element={<RelocationPage />} />
              <Route path="/relocation/register" element={<RegisterPage />} />
              <Route path="/relocation/:id" element={<RelocationDetail />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
